import styled from 'styled-components'
import { InputWrap } from 'ui/components/forms/Input/styled'
import { SelectWrap } from 'ui/components/forms/Select/styled'

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FieldsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FieldsRow = styled.div`
  display: flex;
  gap: 24px;

  ${SelectWrap} {
    flex: 1 1 0;
    min-width: 0;
    margin-bottom: 0;
  }

  ${InputWrap} {
    flex: 3 1 0;
    min-width: 0;
    margin-bottom: 0;
  }
`

export const ButtonsWrap = styled.div`
  display: flex;
  gap: 8px;
  max-width: 246px;
`
